import { Component, computed, effect, inject, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonComponent } from "../button/button.component";
import { EnvironmentStore } from '@program-suite/data-common';

@Component({
  selector: 'lib-banner',
  imports: [CommonModule, ButtonComponent],
  templateUrl: './banner.component.html',
  styleUrl: './banner.component.scss',
})
export class BannerComponent {
  environment = inject(EnvironmentStore);
  interval: number | null = null;
  isEnvBanner = output<boolean>();
  ngOnInit(): void {
    if (this.environment.context() !== 'prod') {
      document.documentElement.style.setProperty( '0px', '32px');
    } else {
      document.documentElement.style.setProperty( '0px', '0px');
    }
    this.checkVersionUpdates();
  }

  ngOnDestroy() {
    // Clean up interval to prevent memory leaks
    if (this.interval !== null) {
      clearInterval(this.interval);
    }
  }

  private async checkVersionUpdates() {
    // Initial check
    await this.environment.getLatestAppVersion();
    // Set up periodic checks
    const pollTimeMs = this.environment.versionPollTime() * 60 * 1000; // Convert minutes to milliseconds
    this.interval = setInterval(async () => {
      await this.environment.getLatestAppVersion();
    }, pollTimeMs);
  }
  refreshApp() {
    window.location.reload();
  }
}